import { Stack } from 'immutable'
export default function stubImmutableStack() {
  return Stack([])
}
